<template>
    <div class="col-lg-3 col-md-6 col-sm-6" v-for="(item, index) in content" :key="index">
        <div class="card sale-chart">
            <div class="card-body">
                <div class="d-flex">
                    <div class="flex-shrink-0">
                        <div class="sale-detail">
                            <div class="icon">
                                <vue-feather :type=item.icon></vue-feather>
                            </div>
                            <div class="sale-content">
                                <h3>{{ item.title }}</h3>
                                <p>{{ item.value }} </p>
                            </div>
                        </div>
                    </div>
                    <div class="small-chart-view sales-chart" id="sales-chart">
                        <apexchart type="bar" height="100" :options="item?.chart?.options" :series="item?.chart?.series">
                        </apexchart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import charts from '../../../data/charts'
export default {
    name: 'esalesPage',
    data() {
        return {
            content: [{
                title: "Total Sales",
                value: "$54750",
                icon: "shopping-bag",
                chart: charts.sales,
            },
            {
                title: "Total Income",
                value: "$54750",
                icon: "dollar-sign",
                chart: charts.income,
            },
            {
                title: "Order Paid",
                value: "$55900",
                icon: "file-text",
                chart: charts.order,
            },
            {
                title: "Total Visitor",
                value: "$67900",
                icon: "user",
                chart: charts.visitors,
            },
            ],

        }
    }
}
</script>